module.exports = __webpack_public_path__ + "img/2_B.329c12df.webp";